import { provideEffects } from "@ngrx/effects";
import { provideState } from "@ngrx/store";
import { DataSourceFilterService } from "./services/data-source-filter.service";
import { DataSourceFilterEffects } from "./state/datasource-filter/data-source-filter.effects";
import * as fromDataSourceFilter from "./state/datasource-filter";

export function provideDataSourceFilterStore() {
    return [
        provideState(
            fromDataSourceFilter.featureKey,
            fromDataSourceFilter.reducers,
        ),
        provideEffects([DataSourceFilterEffects]),
        DataSourceFilterService,
    ];
}
